import React from 'react';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { AdvancedMarker } from '@vis.gl/react-google-maps'; // Import AdvancedMarker
import { useColorScheme } from '@mui/material/styles';

function MainMap() {
    const { mode } = useColorScheme();
    const colorSchemeMap = { light: "LIGHT", dark: "DARK", system: "FOLLOW_SYSTEM" };
    const position1 = { lat: 28.370108, lng: 76.922603 };
    const position2 = { lat: 19.03681, lng: 73.01582 };
    const position3 = { lat: 12.9715987, lng: 77.5945627 };
    // Function to get the mapped value from the dictionary 
    function getColorScheme(value) { return colorSchemeMap[value] || "UNKNOWN_SCHEME"; }

    return (
        <APIProvider apiKey="AIzaSyBrofpZ8fdySj8Hn5rOc6jepjSZemsjHRo"> {/* Replace with your actual API key */}
            <Map
                mapContainerStyle={{ width: '100vw', height: '400px', borderRadius: '50px', }}
                initialCenter={position1}
                defaultCenter={{ lat: 28.370108, lng: 76.922603 }}
                defaultZoom={4}
                gestureHandling={'greedy'}
                disableDefaultUI={true}
                mapId={'2d5d07f22b694022'}
                reuseMaps={true}
                colorScheme={colorSchemeMap[mode]}
            >
                <AdvancedMarker position={position1} /> {/* Add the AdvancedMarker component */}
                <AdvancedMarker position={position2} /> {/* Add the AdvancedMarker component */}
                <AdvancedMarker position={position3} /> {/* Add the AdvancedMarker component */}
            </Map>
        </APIProvider>
    );
}

export default MainMap;